module.exports = __webpack_public_path__ + "img/scrolldown.5cfae004.svg";